<template>
    <div>
        <MenuPurchase/>
        <PurchaseOrder/>
    </div>
</template>

<script>
    import MenuPurchase from "@/components/admin/purchase/menupurchase/MenuPurchase.vue";
    import PurchaseOrder from "@/components/admin/purchase/PurchaseOrder.vue";

    export default {
        name: "Purchase",
        components: {
            MenuPurchase,
            PurchaseOrder,
        },
    }
</script>

<style scoped>

</style>
